export default {
  name: 'ImgCon',
  props: {
    info: {
      type: Object,
      default: () => {}
    },
    desch: {
      type: String,
      default: '160px'
    },
    width: {
      type: String,
      default: '160px'
    }
  }
};